import React from "react";

export interface RouteConfigContextProps {
  rootPath: string;
  viewPath: string;
}

export const RouteConfigContext = React.createContext<RouteConfigContextProps>({
  rootPath: "",
  viewPath: "",
});

export default RouteConfigContext;
